import { Accordion, ColorVariant, RichText } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

const MARKDOWN_ITEMS = [
  {
    value: 'item-1',
    trigger: '# Is it accessible?',
    content: 'Yes. It adheres to the **WAI-ARIA** design pattern.',
  },
  {
    value: 'item-2',
    trigger: '## Is it styled?',
    content: 'Yes. It comes with default styles that match your *theme*.',
  },
  {
    value: 'item-3',
    trigger: '### Is it animated?',
    content: `
Yes. It has smooth open/close animations powered by CSS.

- Animation is smooth
- Transitions are customizable
- Uses CSS animations
    `,
  },
  {
    value: 'item-4',
    trigger: '#### Does it support code?',
    content: `
\`\`\`javascript
// Yes it supports code blocks
const example = () => {
  console.log("Hello world");
}
\`\`\`
    `,
  },
]

export const AccordionDemo = () => {
  const args = {
    type: 'single' as 'single' | 'multiple',
    collapsible: true,
    titleTypography: 'title-large' as any,
    contentTypography: 'body-medium' as any,
    openIcon: 'expand_more',
    closedIcon: 'expand_less',
  }

  const { titleTypography, contentTypography, ...props } = args

  const dir = 'ltr'
  const bgColor = 'primary-90' as ColorVariant

  const items = MARKDOWN_ITEMS

  return (
    <LayoutDemo title='Accordion' bgColor={`var(--color-${bgColor})`}>
      <Accordion
        style={{
          backgroundColor: `var(--color-${bgColor})`,
          color: `var(--color-on-${bgColor})`,
        }}
        {...props}
        dir={dir}
        titleTypography={{ typography: titleTypography as any }}
        contentTypography={{ typography: contentTypography as any }}
        items={items}
        renderTrigger={(value) => <RichText text={value as string} backgroundColor={bgColor} />}
        renderContent={(value) => <RichText text={value as string} backgroundColor={bgColor} />}
      />
    </LayoutDemo>
  )
}
